import * as React from 'react';
import InputWithOptions, {
  ManualInputFnSignature,
  OnSelectFnSignature,
  InputWithOptionsProps,
} from '../InputWithOptions';
import { DropdownLayoutValueOption } from '../DropdownLayout';

export interface AutoCompleteProps extends InputWithOptionsProps {
  predicate?: (option: DropdownLayoutValueOption) => boolean;
  emptyStateMessage?: React.ReactNode;
  onEmptyState?: () => void;
}

export default class AutoComplete extends InputWithOptions<
  ManualInputFnSignature,
  OnSelectFnSignature,
  AutoCompleteProps
> {}
